import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AnyPage, PageData } from '../state/data-access-page.model';
import { currentDisplayedPagesReported } from '../state/data-access-page.actions';

@Injectable({ providedIn: 'root' })
export class PageMergeService {
  private store = inject(Store);

  handleIncomingData(data: { page_current?: AnyPage; page_left?: AnyPage; page_right?: AnyPage }) {
    if (data.page_current) {
      const page = { ...data.page_current, type: 'current' } as PageData;
      this.store.dispatch(currentDisplayedPagesReported({ pages: [page] }));
      return;
    }

    const pages: PageData[] = [];
    if (data.page_left) {
      pages.push({ type: 'left', ...data.page_left });
    }

    if (data.page_right) {
      pages.push({ type: 'right', ...data.page_right });
    }
    this.store.dispatch(currentDisplayedPagesReported({ pages }));
  }
}
